import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { ClientTypes, FilterType } from "../../../utils/types";

export type FilterDropdownProps = {
  setFilter: (filter: FilterType) => void;
  filter: FilterType;
};

const filters: FilterType[] = [
  { name: "All", value: "All" },
  { name: "ATM", value: ClientTypes.ATM },
  { name: "Vending", value: ClientTypes.VENDING },
  { name: "Air Bnb", value: ClientTypes.AIRBNB },
];

export default function FilterDropdown(props: FilterDropdownProps) {
  const { filter, setFilter } = props;

  return (
    <FormControl fullWidth>
      <InputLabel id="filter-label">Filter</InputLabel>
      <Select
        labelId="filter-label"
        value={filter.value}
        label="filter"
        onChange={(event) => setFilter(event.target)}
      >
        {filters.map((f) => (
          <MenuItem key={f.value} value={f.value}>
            {f.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
